export enum Tags {
  Auth = "Auth",
  Stores = "Stores",
  IPs = "IPs",
  Users = "Users"
}
